module.exports = __webpack_public_path__ + "media/images/plans/photo_location/photo-location-og-image-450c0695d4d1dfc07251250b5468179d.jpg";